import { PetProfileType } from '@/types/PetProfile';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PetProfileUI = {
  allPetProfiles: PetProfileType[];
  isIssueModalOpen: boolean;
  isWeightModalOpen: boolean;
};

const initialState = {
  allPetProfiles: [],
  isIssueModalOpen: false,
  isWeightModalOpen: false,
} as PetProfileUI;

const petProfileUI = createSlice({
  name: 'petProfileUI',
  initialState,
  reducers: {
    setIsIssueModalOpen(state, { payload: isIssueModalOpen }: PayloadAction<boolean>) {
      state.isIssueModalOpen = isIssueModalOpen;
    },
    setIsWeightModalOpen(state, { payload: isWeightModalOpen }: PayloadAction<boolean>) {
      state.isWeightModalOpen = isWeightModalOpen;
    },
    setAllPetProfiles(state, { payload: allProfiles }: PayloadAction<PetProfileType[]>) {
      state.allPetProfiles = allProfiles;
    },
  },
});

export const { setIsIssueModalOpen, setIsWeightModalOpen, setAllPetProfiles } = petProfileUI.actions;
export default petProfileUI;
